import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "EntitiesAndGeotargeting" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingWrapper = _resolveComponent("LoadingWrapper")!
  const _component_CampaignImportBanner = _resolveComponent("CampaignImportBanner")!
  const _component_GeotargetingIncentive = _resolveComponent("GeotargetingIncentive")!
  const _component_TableEntitiesSearchInput = _resolveComponent("TableEntitiesSearchInput")!
  const _component_TableEntities = _resolveComponent("TableEntities")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LoadingWrapper, {
      classes: [
				'CampaignEditorRow',
				'CampaignEditorSubtitle'
			],
      isLoading: _ctx.isLoading,
      tag: "h2"
    }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode(" Entities & Geotargeting ", -1 /* CACHED */)
      ]))]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["isLoading"]),
    _createVNode(_component_CampaignImportBanner),
    _createVNode(_component_LoadingWrapper, {
      classes: [
				'CampaignEditorRow',
				'CampaignEditorText'
			],
      isLoading: _ctx.isLoading,
      tag: "p"
    }, {
      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createTextVNode(" Here you have a complete overview of the studies and entities attached to your campaign. It provides insights into their premiumness levels and allows you to define the needed geotargeting settings. ", -1 /* CACHED */)
      ]))]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["isLoading"]),
    _createVNode(_component_GeotargetingIncentive),
    _createVNode(_component_TableEntitiesSearchInput),
    _createVNode(_component_TableEntities)
  ]))
}